import { createContext, useContext } from 'react';

const NotificationsContext = createContext();

export const useNotificationsContext = () => useContext(NotificationsContext);
export default NotificationsContext;
